import { render, staticRenderFns } from "./Vale.vue?vue&type=template&id=23f6ea88&"
import script from "./Vale.vue?vue&type=script&lang=js&"
export * from "./Vale.vue?vue&type=script&lang=js&"
import style0 from "./Vale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports